import { render, staticRenderFns } from "./TabPending.vue?vue&type=template&id=fe3a178e&scoped=true&"
import script from "./TabPending.vue?vue&type=script&lang=js&"
export * from "./TabPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3a178e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe3a178e')) {
      api.createRecord('fe3a178e', component.options)
    } else {
      api.reload('fe3a178e', component.options)
    }
    module.hot.accept("./TabPending.vue?vue&type=template&id=fe3a178e&scoped=true&", function () {
      api.rerender('fe3a178e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/TabPending.vue"
export default component.exports